var map = {
	"./020225 First-Week.jpg": 639,
	"./022325 Vienna+Prague.jpg": 469,
	"./030225 Edinburgh.jpg": 5743,
	"./033125 Switzerland.jpg": 3618,
	"./040425 Slovenia.jpg": 3937,
	"./042025 Seville+Barcelona.jpg": 9742,
	"./042825 Mallorca+Italy.jpg": 8827,
	"./051225 Balaton+Sardinia.jpg": 1361,
	"./051925 Austria+Bavaria.jpg": 3350
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 522;